import React, { Component } from "react";
import { View, Image, TouchableOpacity, ScrollView, Alert } from "react-native";
import { icons } from "../theme/icons";
import {
  appStyles,
  componentStyles,
  customerLocationStyles,
  fillCustomerAddressStyles,
} from "../theme/styles";
import TextView from "../components/TextView";
import LinearGradient from "react-native-linear-gradient";
import Button from "../components/Button";
import { blueDarkColor, blueLightColor } from "../theme/colors";
import Waiting from "../components/Waiting";
import {
  cartChooseAddressRequest,
  areaRequest,
  citiesRequest,
  isActiveInsuranceRequest,
} from "../utils/api";
import DialogList from "../components/DialogList";
import DialogPrompt from "../components/DialogPrompt";
import { showMessage, getError } from "../utils/utils";
import TextInput from "../components/TextInput/TextInput";
import { wp } from "../utils/responsive";
var theme = {
  colors: {
    text: "black",
    error: "red",
    primary: "#000000cc",
    outlineColor: "#eeeeee",
    placeholder: "gray",
  },
};

export default class FillCustomerAddressScreen extends Component {
  constructor(props) {
    super(props);
    var city = null;
    var area = null;
    if (props.route.params.infoCity != null) {
      city = {
        id: props.route.params.infoCity.cityid,
        name: props.route.params.infoCity.cityname,
      };

      area = {
        id: props.route.params.infoCity.areaid,
        name: props.route.params.infoCity.areaname,
        number: props.route.params.infoCity.areanumber,
      };
    }
    this.state = {
      favorits: [
        {
          id: 0,
          icon: "plus",
          title: "افزودن آدرس منتخب",
        },
      ],
      comment: "",
      showPrompt: false,
      promptMessage: "آیا تحت پوشش بیمه هستید ؟",
      areaModal: false,
      cityModal: false,
      areas: [],
      cities: [],
      ready: false,
      selectedCity: city,
      selectedArea: area,
      koche: "",
      vahed: "",
      pelak: "",
      address: props.route.params.address,
      lat: props.route.params.latitude,
      lng: props.route.params.longitude,
      waiting: false,
    };
    this.inputs = {};

    console.log(props);
  }
  focusTheField = (prev, next) => {
    this.inputs[prev].blur();

    this.inputs[next].focus();
  };
  _keyExtractor = (item, index) => index.toString();
  renderFavoritRow({ item, index }) {
    return (
      <TouchableOpacity style={componentStyles.favoritItem} activeOpacity={0.5}>
        <TextView>{item.title}</TextView>
        <Image source={icons[item.icon]} style={componentStyles.favoritIcon} />
      </TouchableOpacity>
    );
  }
  render() {
    return (
      <View style={appStyles.flex1}>
        <View style={appStyles.toolbarWraper}>
          <Image
            source={icons["ad"]}
            style={[appStyles.toolbarIcon, { tintColor: "#31BFCF" }]}
          />
          <TextView style={appStyles.toolbarTitle}>
            {this.props.route.params.addressId === 0
              ? "تکمیل آدرس مددجو"
              : "آدرس منتخب"}
          </TextView>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.goBack();
            }}
          >
            <Image source={icons["back"]} style={appStyles.backIcon} />
          </TouchableOpacity>
        </View>
        <ScrollView enableOnAndroid={true} keyboardShouldPersistTaps="handled">
          <LinearGradient
            colors={[blueDarkColor, blueLightColor]}
            style={fillCustomerAddressStyles.wraper}
          >
            <View style={[appStyles.center, { marginBottom: 250 }]}>
              <Image
                source={icons["address_pin"]}
                style={fillCustomerAddressStyles.addressIcon}
              />
              {this.props.route.params.addressId === 0 ? (
                <TextView style={fillCustomerAddressStyles.addresstext}>
                  {"آدرس مددجو \n\n" + this.state.address}
                </TextView>
              ) : (
                <TextView style={fillCustomerAddressStyles.addresstext}>
                  {this.props.route.params.nameaddress}
                </TextView>
              )}
              {this.props.route.params.addressId === 0 ? (
                <TextView style={fillCustomerAddressStyles.addresstext}>
                  لطفا آدرس دقیق مددجو را وارد کنید
                </TextView>
              ) : (
                <TextView style={fillCustomerAddressStyles.addresstext}>
                  {this.props.route.params.address}
                </TextView>
              )}
            </View>
            <View
              style={[
                appStyles.bottomView,
                appStyles.center,
                this.props.route.params.addressId === 0
                  ? { height: 330 }
                  : null,
              ]}
            >
              {/* {this.props.route.params.addressId === 0 ? (
                <View style={appStyles.row}>
                  <TouchableOpacity
                    style={fillCustomerAddressStyles.textMidInput}
                    onPress={() => {
                      this.setState({
                        areaModal: true,
                      });
                    }}
                  >
                    <TextView>
                      {this.state.selectedArea != null
                        ? this.state.selectedArea.name
                        : "منطقه"}
                    </TextView>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={fillCustomerAddressStyles.textMidInput}
                    onPress={() => {
                      this.setState({
                        cityModal: true,
                      });
                    }}
                  >
                    <TextView>
                      {this.state.selectedCity != null
                        ? this.state.selectedCity.name
                        : "شهر"}
                    </TextView>
                  </TouchableOpacity>
                </View>
              ) : null} */}
              {this.props.route.params.addressId === 0 ? (
                <View style={[appStyles.center, { marginBottom: 15 }]}>
                  <TextInput
                    placeholder="کوچه"
                    mode="outlined"
                    theme={theme}
                    ref={(input) => {
                      this.inputs["koche"] = input;
                    }}
                    returnKeyType={"next"}
                    onSubmitEditing={() => {
                      this.focusTheField("koche", "pelak");
                    }}
                    wrapperStyle={{ width: wp(90) }}
                    onChangeText={(text) => {
                      this.setState({
                        koche: text,
                      });
                    }}
                    value={this.state.koche}
                  />
                  <View style={appStyles.row}>
                    <TextInput
                      placeholder="واحد"
                      inputType="numeric"
                      mode="outlined"
                      theme={theme}
                      ref={(input) => {
                        this.inputs["vahed"] = input;
                      }}
                      returnKeyType={"done"}
                      onSubmitEditing={() => {}}
                      wrapperStyle={{ width: wp(42) }}
                      onChangeText={(text) => {
                        this.setState({
                          vahed: text,
                        });
                      }}
                      value={this.state.vahed}
                    />
                    <TextInput
                      placeholder="پلاک"
                      inputType="numeric"
                      mode="outlined"
                      theme={theme}
                      ref={(input) => {
                        this.inputs["pelak"] = input;
                      }}
                      returnKeyType={"next"}
                      onSubmitEditing={() => {
                        this.focusTheField("pelak", "vahed");
                      }}
                      wrapperStyle={{ width: wp(42) }}
                      onChangeText={(text) => {
                        this.setState({
                          pelak: text,
                        });
                      }}
                      value={this.state.pelak}
                    />
                  </View>
                  <TextInput
                    placeholder="توضیحات"
                    mode="outlined"
                    theme={theme}
                    ref={(input) => {
                      this.inputs["koche"] = input;
                    }}
                    returnKeyType={"next"}
                    onSubmitEditing={() => {
                      this.focusTheField("koche", "pelak");
                    }}
                    wrapperStyle={{ width: wp(90) }}
                    onChangeText={(text) => {
                      this.setState({
                        comment: text,
                      });
                    }}
                    value={this.state.comment}
                  />
                </View>
              ) : null}
              <Button
                style={customerLocationStyles.button}
                text="تایید و ادامه"
                textStyle={customerLocationStyles.buttonText}
                showArrow={true}
                onPress={() => {
                  if (this.props.route.params.addressId > 0) {
                    this.setState({
                      waiting: true,
                    });
                    cartChooseAddressRequest(
                      this.props.route.params.addressId,
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      (isConnect, response) => {
                        if (isConnect && response.isSuccess) {
                          isActiveInsuranceRequest((isConnect, response) => {
                            if ((response?.data?.deactive === 0)) {
                              this.setState({
                                waiting: false,
                                showPrompt: true,
                              });
                            } else {
                              this.setState({
                                waiting: false,
                              });
                              this.props.navigation.navigate("services");
                            }
                          });
                        } else {
                          this.setState({
                            waiting: false,
                          });
                          showMessage("", getError(response));
                        }
                      }
                    );
                  } else {
                    if (this.state.selectedCity != null) {
                      this.setState({
                        waiting: true,
                      });

                      cartChooseAddressRequest(
                        "",
                        this.state.selectedCity.id,
                        this.state.selectedArea != null
                          ? this.state.selectedArea.id
                          : "",
                        this.state.koche,
                        this.state.vahed,
                        this.state.pelak,
                        this.state.address,
                        this.state.lat,
                        this.state.lng,
                        this.state.comment,
                        (isConnect, response) => {
                          if (isConnect && response.isSuccess) {
                            isActiveInsuranceRequest((isConnect, response) => {
                              if ((response?.data?.deactive === 0)) {
                                this.setState({
                                  waiting: false,
                                  showPrompt: true,
                                });
                              } else {
                                this.setState({
                                  waiting: false,
                                });
                                this.props.navigation.navigate("services");
                              }
                            });
                          } else {
                            this.setState({
                              waiting: false,
                            });
                            showMessage("", getError(response));
                          }
                        }
                      );
                    } else {
                      showMessage("", "لطفا شهر خود را انتخاب نمایید");
                    }
                  }
                }}
              />
            </View>
          </LinearGradient>
        </ScrollView>
        <DialogList
          show={this.state.cityModal}
          title="انتخاب شهر"
          field="name"
          data={this.state.cities}
          onSelect={(item, index) => {
            this.setState({
              cityModal: false,
              selectedCity: item,
            });
            areaRequest(item.id, (isConnect, response) => {
              if (isConnect && response.isSuccess) {
                this.setState({
                  areas: response.data,
                });
              }
            });
          }}
          onCancel={() => {
            this.setState({
              cityModal: false,
            });
          }}
        />
        <DialogList
          show={this.state.areaModal}
          title="انتخاب منطقه"
          field="name"
          data={this.state.areas}
          onSelect={(item, index) => {
            this.setState({
              areaModal: false,
              selectedArea: item,
            });
          }}
          onCancel={() => {
            this.setState({
              areaModal: false,
            });
          }}
        />
        <DialogPrompt
          show={this.state.showPrompt}
          message={this.state.promptMessage}
          onApprove={() => {
            this.setState({
              showPrompt: false,
            });
            this.props.navigation.navigate("insurance");
          }}
          onCancel={() => {
            this.setState({
              showPrompt: false,
            });
            this.props.navigation.navigate("services");
          }}
          onClose={() => {
            this.setState({
              showPrompt: false,
            });
          }}
        />
        <Waiting waiting={this.state.waiting} />
      </View>
    );
  }
  componentWillMount() {
    citiesRequest((isConnect, response) => {
      if (isConnect && response.isSuccess) {
        this.setState({
          cities: response.data,
        });
      }
    });
  }
}
